import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined";
import { Popover } from "@mui/material";
import { type FC, type MouseEvent, useCallback, useState } from "react";

import { useFilterChipVariant } from "~/components/UI/FilterChip";
import { FilterMenuTitle } from "~/components/UI/FilterMenuTitle";
import { FilterTabs } from "~/components/UI/FilterTabs";
import { RichTooltip } from "~/components/UI/RichTooltip";

import { FILTER_MODE_TOOLTIP, metricsScopeOptions } from "./config";
import * as Styled from "./StatusFilterDropdown.styles";
import { useStatusFilterDropdown } from "./useStatusFilterDropdown";

export const StatusFilterDropdown: FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isToolbar = useFilterChipVariant() === "toolbar";

  const {
    chipLabel,
    selectedStatus,
    selectedScope,
    statusOptions,
    onChangeStatus,
    onChangeScope,
  } = useStatusFilterDropdown();

  const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <Styled.Chip onClick={handleOpen} toolbar={isToolbar}>
        {isToolbar && <ToggleOnOutlinedIcon className="StatusChip-icon" />}
        <Styled.ChipLabel>Status</Styled.ChipLabel>
        <Styled.ChipValue>{chipLabel}</Styled.ChipValue>
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </Styled.Chip>

      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Styled.Content>
          <Styled.Section>
            <Styled.SectionTitle>
              <FilterMenuTitle>Filter Mode</FilterMenuTitle>
              <RichTooltip title={FILTER_MODE_TOOLTIP} maxWidth={280}>
                <InfoOutlinedIcon color="disabled" fontSize="inherit" />
              </RichTooltip>
            </Styled.SectionTitle>
            <FilterTabs
              options={metricsScopeOptions}
              value={selectedScope}
              onChange={onChangeScope}
              fullWidth
            />
          </Styled.Section>

          <Styled.Section>
            <FilterMenuTitle>Status</FilterMenuTitle>
            <FilterTabs
              options={statusOptions}
              value={selectedStatus}
              onChange={onChangeStatus}
              fullWidth
            />
          </Styled.Section>
        </Styled.Content>
      </Popover>
    </>
  );
};
